import type { IconData } from '@stacksjs/iconify-core'

export const businessProgressBar2: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M14 36a6 6 0 1 0 12 0a6 6 0 1 0-12 0m22.144-3.649c.132-1.398 1.398-2.045 2.659-1.427a36 36 0 0 1 3.21 1.803c1.04.65 1.814 1.203 2.388 1.66c1.136.902 1.136 2.323 0 3.226a26 26 0 0 1-2.387 1.66a36 36 0 0 1-3.21 1.802c-1.262.618-2.529-.03-2.66-1.428C36.06 38.767 36 37.582 36 36c0-1.583.061-2.768.144-3.649M36 36H26m-12 0H3m17-6V11m0-2.63c0-1.24 1.11-2.15 2.31-1.834c1.757.463 4.484 1.279 8.067 2.646a64 64 0 0 1 3.765 1.56c2.422 1.107 2.422 3.41 0 4.517c-.99.452-2.225.972-3.766 1.56C23.706 19.364 20 20 20 20z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default businessProgressBar2
